import { FC } from "react";
import { Outlet } from "react-router-dom";

interface Props {
  element?: any;
  path?: string;
}

export const DashboardRoute: FC<Props> = () => {
  return <Outlet />;
};
